import { Box, Text, Flex } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'

const ProductIntro2 = () => {
  return (
    <Box className="w-full mx-auto h-full relative">
      <Image
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/1740463947822-1740463970954.jpg"
        alt="five tumbler"
        width={3228}
        height={7948}
        className="w-full h-full object-cover"
      />

      <Box className="absolute inset-0 z-10">
        <Flex className="absolute top-[2%] left-[5%] md:gap-8 gap-2 flex-col w-full">
          <Text
            color={COLOR.YELLOW}
            className="uppercase rounded-xl border-4 md:py-4 md:px-6 py-1 px-2 w-min xl:text-2xl lg:text-xl md:text:lg text-xs font-semibold whitespace-nowrap h-min"
            borderColor={COLOR.YELLOW}
          >
            Process extraction
          </Text>

          <Flex direction="column" className="md:gap-2 gap-1">
            <Text
              color={COLOR.YELLOW}
              className="xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              Obtained the highest level of FDA GRAS #000413 certification
            </Text>
            <Text
              color={COLOR.LIGHT}
              className="uppercase lg:w-3/5 w-full font-bold xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              [100% safety check] [100% international certification]
            </Text>
          </Flex>

          <Flex direction="column" className="md:gap-2 gap-1">
            <Text
              color={COLOR.YELLOW}
              className="xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              Exclusive extraction technology
            </Text>
            <Text
              color={COLOR.LIGHT}
              className="uppercase lg:w-3/5 w-full font-bold xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              Unique ultrasonic extraction
            </Text>
          </Flex>

          <Flex direction="column" className="md:gap-2 gap-1">
            <Text
              color={COLOR.YELLOW}
              className="xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              World's highest standard certification
            </Text>
            <Text
              color={COLOR.LIGHT}
              className="uppercase lg:w-3/5 w-full font-bold xl:text-2xl lg:text-xl md:text:lg sm:text-sm text-xs"
            >
              Obtained USDA ORGANIC certification from the United States
              Department of Agriculture
            </Text>
          </Flex>
        </Flex>

        <Flex
          className="absolute left-1/2 -translate-x-1/2 top-[21.4%] w-[26%] min-w-[150px] h-[4%] flex-col justify-center items-center"
          bgColor={COLOR.YELLOW}
        >
          <Text
            color={COLOR.LIGHT}
            className="font-bold lg:text-2xl md:text-lg sm:text-base text-xs"
          >
            ReiShi
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="font-bold lg:text-2xl md:text-lg sm:text-base text-xs"
          >
            Beta-Gluean 1-3, 1-6
          </Text>
        </Flex>

        <Flex
          direction="column"
          className="items-center absolute w-full top-[26%] left-1/2 tranform -translate-x-1/2 xl:gap-6 lg:gap-4 md:gap-2 gap-1"
        >
          <Text
            className="uppercase xl:text-4xl lg:text-3xl md:text-2xl sm:text-lg font-bold text-center leading-normal"
            color={COLOR.LIGHT}
          >
            Polysaccharides quickly <br className="hidden xl:inline" />
            revitalize skin
          </Text>

          <Text
            className="xl:text-2xl lg:text-xl md:text:lg text-xs uppercase font-bold"
            color={COLOR.YELLOW}
          >
            Unleash infinite vitality
          </Text>

          <Text
            color={COLOR.LIGHT}
            className="text-center xl:text-xl lg:text-lg md:text-base text-xs xl:w-3/5 lg:w-4/5 px-2 w-full max-[390px]:text-left"
          >
            Zero2One Luminous ReiShi Essence is packed with the power of nature.
            We extract polysaccharides from Ganoderma lucidum. This special
            bioactive ingredient penetrates into the scalp quickly, activates
            scalp cells, and awakens the hidden energy of the scalp.
          </Text>
        </Flex>

        <Flex className="justify-center absolute top-[55%] left-1/2 transform -translate-x-1/2 w-full">
          <Text
            className="text-center xl:text-2xl lg:text-xl md:text:lg sm:text-xs md:w-4/6 w-full p-2 text-[10px]"
            color={COLOR.LIGHT}
          >
            The ultimate formula that combines Ganoderma lucidum multiflora and
            Salvia miltiorrhiza root extract, using advanced technology to
            maximize its skin care effectiveness. Among them, Ganoderma lucidum
            polysaccharides have extremely high biological activity, which can
            stimulate the vitality of hair follicle cells and further strengthen
            scalp health. Salvia root extract has excellent moisturizing,
            conditioning and soothing effects. Create a healthy environment for
            your scalp. Polygonum multiflorum extract is added to give the hair
            a natural color and luster, strengthen the hair roots, and bring you
            healthier and brighter hair.
          </Text>
        </Flex>

        <Flex
          className="absolute right-[5%] top-[69.5%] w-[26%] h-[1.2%] justify-center items-center"
          bgColor={COLOR.YELLOW}
        >
          <Text
            color={COLOR.LIGHT}
            className="font-bold lg:text-lg md:text-xs sm:text-[10px] text-[6px]"
          >
            Salvia Miltiorrhiza Root Extract
          </Text>
        </Flex>

        <Box className="absolute right-[5.2%] top-[71.5%] w-[26%]">
          <Text
            color={COLOR.LIGHT}
            className="font-bold lg:text-base md:text-xs sm:text-[10px] text-[6px]"
          >
            Salvia miltiorrhiza extract is authorized by the Academy of
            Agricultural Sciences
          </Text>
        </Box>

        <Flex
          direction="column"
          className="absolute xl:gap-10 md:gap-4 gap-2 items-center top-[77%] left-1/2 transform -translate-x-1/2 w-full"
        >
          <Text
            color={COLOR.LIGHT}
            className="xl:text-4xl lg:text-2xl md:text-xl sm:text:lg text-xs uppercase font-extrabold"
          >
            The hair vitality!
          </Text>
          <Text
            color={COLOR.LIGHT}
            className="xl:text-2xl lg:text-xl md:text:lg text-xs text-center md:w-3/5 w-full px-2"
          >
            In laboratory cell proliferation activity tests, Ganoderma lucidum
            extract and cell culture for 24/48 hours showed a positive
            concentration-related ability to promote cell proliferation.
          </Text>
        </Flex>

        <Flex
          direction="column"
          className="absolute bottom-10 left-1/2 transform -translate-x-1/2 items-center w-full"
        >
          <Flex className="items-center md:gap-4 gap-2">
            <Text
              className="text-center italic xl:text-9xl lg:text-7xl md:text-6xl text-4xl"
              color={COLOR.LIGHT}
            >
              6
            </Text>
            <Text
              className="text-center xl:text-4xl lg:text-3xl md:text-2xl text-xl"
              color={COLOR.LIGHT}
            >
              effects in one go
            </Text>
          </Flex>
          <Text
            className="text-center uppercase xl:text-xl lg:text-base sm:text-sm text-xs"
            color={COLOR.LIGHT}
          >
            Scalp repair ・ moisturizing ・ conditioning ・ soothing
            <br />
            revitalizing ・ and strengthening hair roots
          </Text>
        </Flex>
      </Box>
    </Box>
  )
}

export default ProductIntro2
